import { USER_ROLES, ROLE_PERMISSIONS } from '../constants';

/**
 * Obtiene las iniciales de un nombre
 * @param {string} nombre - Nombre completo del usuario
 * @returns {string} - Iniciales en mayúsculas (máximo 2 caracteres)
 */
export const getInitials = (nombre) => {
  if (!nombre) return '';
  
  return nombre
    .split(' ')
    .map(word => word.charAt(0))
    .join('')
    .toUpperCase()
    .slice(0, 2);
};

/**
 * Formatea número de celular para mostrar
 * @param {string} celular - Número de celular
 * @returns {string} - Número formateado
 */
export const formatCelular = (celular) => {
  if (!celular) return '';
  
  if (celular.startsWith('52') && celular.length === 12) {
    return `+${celular.slice(0, 2)} ${celular.slice(2, 5)} ${celular.slice(5, 8)} ${celular.slice(8)}`;
  }
  return celular;
};

/**
 * Genera permisos por defecto basados en el rol usando el sistema centralizado
 * @param {string} rol - Rol del usuario
 * @returns {Object} - Objeto con permisos por defecto
 */
export const generateDefaultPermissions = (rol) => {
  return ROLE_PERMISSIONS[rol] || {};
};

/**
 * Procesa lista de usuarios agregando permisos por defecto
 * @param {Array} users - Lista de usuarios del backend
 * @returns {Array} - Lista de usuarios con permisos
 */
export const processUsersWithPermissions = (users) => {
  if (!Array.isArray(users)) return [];
  
  return users.map(user => ({
    ...user,
    permisos: generateDefaultPermissions(user.rol)
  }));
};

/**
 * Filtra usuarios por término de búsqueda
 * @param {Array} users - Lista de usuarios
 * @param {string} searchTerm - Término de búsqueda
 * @returns {Array} - Usuarios filtrados
 */
export const filterUsers = (users, searchTerm) => {
  if (!searchTerm || !Array.isArray(users)) return users;
  
  const term = searchTerm.toLowerCase();
  
  return users.filter(user =>
    user.nombre?.toLowerCase().includes(term) ||
    user.correo?.toLowerCase().includes(term) ||
    user.celular?.includes(term) ||
    user.rol?.toLowerCase().includes(term)
  );
}; 